"use strict";

import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _defineProperty from "@babel/runtime/helpers/defineProperty";
import { Fields, System } from "Constants/objects";

var FilterField =
/*#__PURE__*/
function () {
  /**
   *
   * @param {object} field FormFilterField
   * @param {Array} viewSource FormFields
   */
  function FilterField(field, viewSource) {
    _classCallCheck(this, FilterField);

    _defineProperty(this, "_field", null);

    _defineProperty(this, "viewSource", void 0);

    this._field = field;
    this.viewSource = viewSource;
    this.tableField = this.viewSource.find(function (item) {
      return item[Fields.ObjectFieldID] === field[Fields.ObjectFieldID];
    });
  }

  _createClass(FilterField, [{
    key: "isTableField",
    value: function isTableField() {
      return this.tableField != null;
    }
  }, {
    key: "getObjectFieldType",
    value: function getObjectFieldType() {
      return this.isTableField() ? this._field[Fields.ObjectFieldID_FieldType] || this._field[Fields.FieldType] : this._field[Fields.LinkedObjectID_DisplayObjectFieldID_FieldType] || this._field[Fields.FieldType];
    }
  }, {
    key: "isLookup",
    value: function isLookup() {
      return this.getLinkedName() && this.getDisplayObjectFieldIDName();
    }
  }, {
    key: "getLinkedName",
    value: function getLinkedName() {
      return this.isTableField() ? this._field[Fields.ObjectFieldID_LinkedObjectID_Name] : this._field[Fields.LinkedObjectID_Name];
    }
  }, {
    key: "getKeyObjFieldName",
    value: function getKeyObjFieldName() {
      return this.isTableField() ? this._field[Fields.ObjectFieldID_KeyObjectFieldID_Name] : this._field[Fields.LinkedObjectID_KeyObjectFieldID_Name];
    }
  }, {
    key: "getDisplayObjectFieldIDName",
    value: function getDisplayObjectFieldIDName() {
      return this.isTableField() ? this._field[Fields.ObjectFieldID_DisplayObjectFieldID_Name] : this._field[Fields.LinkedObjectID_DisplayObjectFieldID_Name];
    }
  }, {
    key: "getFieldType",
    value: function getFieldType() {
      var fieldType = this.getObjectFieldType();
      if (this.isLookup()) return this._field[Fields.IsMultiselect] ? System.DX_CONTROLS.dxTagBox : System.DX_CONTROLS.dxSelectBox;

      switch (fieldType) {
        case System.FIELD_TYPE.NUMBER:
          return System.DX_CONTROLS.dxNumberBox;

        case System.FIELD_TYPE.DATE:
          return System.DX_CONTROLS.dxDateBox;

        case System.FIELD_TYPE.BOOL:
          return System.DX_CONTROLS.dxCheckBox;

        case System.FIELD_TYPE.BUTTON:
          return System.DX_CONTROLS.dxButton;

        default:
          return System.DX_CONTROLS.dxTextBox;
      }
    }
  }, {
    key: "formIDObjectIDName",
    get: function get() {
      return this._field[Fields.FormID_ObjectID_Name];
    }
  }, {
    key: "Name",
    get: function get() {
      return this._field[Fields.Name];
    }
  }, {
    key: "ID",
    get: function get() {
      return this._field[Fields.ID];
    }
  }, {
    key: "ObjectFieldID",
    get: function get() {
      return this._field[Fields.ObjectFieldID];
    }
  }, {
    key: "required",
    get: function get() {
      return this._field[Fields.IsRequired];
    }
  }, {
    key: "title",
    get: function get() {
      return this._field[Fields.Title];
    }
  }]);

  return FilterField;
}();

export { FilterField as default };